<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row class="mb-3">
        <v-col cols="12" md="5">
          <DateIOSPicker outlined dense hide-details label="Ngày yêu cầu" :date.sync="inputDate" />
        </v-col>
        <v-col cols="12" md="6">
          <v-autocomplete
            outlined
            dense
            hide-details
            label="Trạng thái"
            item-text="title"
            item-value="id"
            v-bind="this.$attrs"
            clearable
            v-model="status"
            :items="[
              { title: 'Đã duyệt', value: 'approved' },
              { title: 'Chưa duyệt', value: 'created' }
            ]"
            return-object
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="11">
          <GradeClassStudentSelect ref="gcsSelect" @changed="gradeClassStudentChange" />
        </v-col>
        <div class="filter-submit">
          <v-btn outlined color="#0D47A1" @click="onFilterChanged">
            Tìm kiếm
          </v-btn>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import { inputRules } from '@/plugins/rule'
import moment from 'moment'
import { get } from 'lodash'

export default {
  components: {
    GradeClassStudentSelect,
    DateIOSPicker
  },
  data: () => ({
    PeriodType: 0,
    rules: inputRules,
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: null,
    status: {},
    tuitionPeriod: '',
    inputDate: '',
    windowWidth: window.innerWidth
  }),
  computed: {
    filterFactor() {
      return {
        subject: get(this.subjectData, 'id'),
        semesterType: this.semesterData.type
      }
    },
    filterSubject() {
      return {
        division: get(this.classData, 'division.id'),
        grade: get(this.classData, 'grade.id')
      }
    }
  },
  created() {
    this.inputDate = moment().toISOString()
    this.semesterData = this.currentSemester
  },
  methods: {
    ...mapActions('absentRequest', ['fetchSbsentRequests']),
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student.id
    },

    async onFilterChanged() {
      const query = {
        status: this.status ? this.status.value : undefined,
        studentGrade: this.selectedGrade,
        studentClass: this.selectedClass,
        student: this.selectedStudent ? this.selectedStudent : undefined,
        date: this.inputDate ? moment(this.inputDate).format('YYYY-MM-DD') : undefined
      }
      this.$loading.active = true
      await this.fetchSbsentRequests({ ...query, isAdmin: true })
      this.$loading.active = false
    },
    semesterChanged() {
      this.factorData = null
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }

  .filter-options {
    flex: 1;
  }

  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
